export enum LoadAccessorialEnum {
    DEAD_HEAD = 'Dead Head',
    CHAINUP_TOWUP = 'Chainup/Tow Up',
}
